import { t } from "../../i18n";
import { Folder, FolderSearch, Upload } from "lucide-react";
import { ArtifactCard } from "../artifacts/ArtifactCard";
import { asRecord } from "./ToolResultView.utils";
import { GenericResult } from "./GenericResult";
import { Card } from "./WorkspaceResultCard";
import { Heading } from "./WorkspaceResultHeading";
import { FileList } from "./WorkspaceResultFileList";
import { PathLabel } from "./WorkspaceResultPathLabel";
import { ReadResult } from "./WorkspaceResultRead";
import { EditResult } from "./WorkspaceResultEdit";
import { SearchResult } from "./WorkspaceResultSearch";
import { ProxmoxResult } from "./WorkspaceResultProxmox";
import { pathsFrom, recordValue, text } from "./WorkspaceResult.utils";

export function WorkspaceResult({
  name,
  argumentsValue,
  result,
}: {
  name: string;
  argumentsValue: unknown;
  result: unknown;
}) {
  const input = recordValue(argumentsValue);
  if (name === "agent_workspace_upload_artifact") {
    const values = recordValue(result);
    const artifact = asRecord(values.artifact);
    return (
      <Card tone="emerald">
        <Heading
          icon={
            <Upload
              size={16}
              className="text-emerald-700 dark:text-emerald-300"
            />
          }
        >
          {t("Artifact uploaded to workspace")}
        </Heading>
        <PathLabel
          path={
            text(values.path) || text(input.path) || t("Workspace destination")
          }
        />
        {artifact ? (
          <div className="mt-3">
            <ArtifactCard artifact={artifact} />
          </div>
        ) : null}
      </Card>
    );
  }
  if (name === "workspace_read")
    return <ReadResult input={input} result={result} />;
  if (
    name === "workspace_edit" ||
    name === "workspace_overwrite" ||
    name === "workspace_write" ||
    name === "workspace_patch"
  )
    return <EditResult name={name} input={input} result={result} />;
  if (name === "workspace_list")
    return (
      <FileList
        paths={pathsFrom(result)}
        title={t("Workspace files")}
        icon={<Folder size={16} className="text-amber-600" />}
      />
    );
  if (name === "workspace_glob")
    return (
      <FileList
        paths={pathsFrom(result)}
        title={t("Matching workspace paths")}
        icon={
          <FolderSearch
            size={16}
            className="text-violet-700 dark:text-violet-300"
          />
        }
      />
    );
  if (name === "workspace_rg")
    return <SearchResult input={input} result={result} />;
  if (name.startsWith("proxmox_"))
    return <ProxmoxResult name={name} result={result} />;
  return <GenericResult value={result} />;
}
